export function removeBlankPropertyFromObject<T>(obj: T): T {
    const acc: Partial<T> = {};
    for (const key in obj) {
      if (obj[key]) acc[key] = obj[key];
    }
    return acc as T;
  }